import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Icon",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19 9.98a3.006 3.006 0 0 0-2.107-2.873 3.003 3.003 0 0 0-.588-3.425 3.017 3.017 0 0 0-3.431-.587A3.017 3.017 0 0 0 9.996 1a3.026 3.026 0 0 0-2.878 2.095 3.02 3.02 0 0 0-3.467.586 3.007 3.007 0 0 0-.552 3.466A3.023 3.023 0 0 0 1 10.02a3.014 3.014 0 0 0 2.099 2.873 3.005 3.005 0 0 0 .586 3.46 3.016 3.016 0 0 0 3.473.552A3.018 3.018 0 0 0 10.036 19a3.026 3.026 0 0 0 2.878-2.095 3.02 3.02 0 0 0 3.43-.588 3.007 3.007 0 0 0 .59-3.424A3.013 3.013 0 0 0 19 9.98ZM7.037 13.189l6.431-6.42",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.64 8.776c.777 0 1.407-.629 1.407-1.404 0-.776-.63-1.404-1.407-1.404a1.406 1.406 0 1 0 0 2.808ZM12.865 13.993a1.406 1.406 0 1 0 0-2.809 1.406 1.406 0 1 0 0 2.809Z",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }